import { create } from 'zustand';
import cuid from 'cuid';
import { TOAST_DURATION_MS, TOAST_TYPES } from '../constant/toast';

export const useSettingsStore = create(set => ({
  isAppEnabled: false,
  setIsAppEnabled: isAppEnabled => {
    set({ isAppEnabled });
  },
  isAppFinished: false,
  setIsAppFinished: isAppFinished => {
    set({ isAppFinished });
  },
  hasPendingCachedImages: false,
  setHasPendingCachedImages: hasPendingCachedImages => {
    set({ hasPendingCachedImages });
  },
  prevMetadata: undefined,
  setPrevMetadata: prevMetadata => {
    set({ prevMetadata });
  },
  toasts: [],
  showToast: (
    lines,
    {
      duration = TOAST_DURATION_MS,
      type = TOAST_TYPES.WARNING,
      style = {}
    } = {}
  ) =>
    set(state => ({
      toasts: [
        ...state.toasts,
        { id: cuid(), lines, duration, type, style }
      ]
    })),
  hideToast: id =>
    set(state => ({
      toasts: state.toasts.filter(item => item.id !== id)
    }))
}));
